module.exports = __webpack_public_path__ + "flyer_image_overlay_blue_wave_12-2bd6fc15008f252c9ee4430ba558dd44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/flyer_image_overlay_blue_wave_12.png
// module id = 1560
// module chunks = 1